export enum HomePageActionTypes {
    // API_RESPONSE_SUCCESS = '@@homePage/API_RESPONSE_SUCCESS',
    // API_RESPONSE_ERROR = '@@homePage/API_RESPONSE_ERROR',
    // USER_LOGGED_IN = '@@homePage/USER_LOGGED_IN',
    FETCH_BUILDING_REQUEST = '@@homePage/FETCH_BUILDING_REQUEST',
    FETCH_BUILDING_SUCCESS = '@@homePage/FETCH_BUILDING_SUCCESS',
    FETCH_BUILDING_FAILURE = '@@homePage/FETCH_BUILDING_FAILURE',
    FETCH_FLOOR_REQUEST = '@@homePage/FETCH_FLOOR_REQUEST',
    FETCH_FLOOR_SUCCESS = '@@homePage/FETCH_FLOOR_SUCCESS',
    FETCH_FLOOR_FAILURE = '@@homePage/FETCH_FLOOR_FAILURE',
    SET_ACTIVE_BUILDING = '@@homePage/SET_ACTIVE_BUILDING',
    SET_ACTIVE_FLOOR = '@@homePage/SET_ACTIVE_FLOOR',
    SET_CUSTOMER_ID = '@@homePage/SET_CUSTOMER_ID',
}
